export default __webpack_public_path__ + "locales/vi/DeleteThirdPartyDialog.json?hash=a8ae1c097013561c021b9e336045c683";